import { WEB_HTTP_CONTEXT, WebHttpRequestOptions } from '@am92/web-http'
import { HANDSHAKE_ENABLED_HTTP, asHttp } from '~/src/Configurations/WebHttp'
import { HANDSHAKE_URL } from '~/src/Configurations/env'

const performHandshake = async () => {
  const promises = HANDSHAKE_ENABLED_HTTP.map(handshake)
  const responses = await Promise.allSettled(promises)
  responses.forEach(response => {
    if (response.status === 'rejected') {
      throw response.reason
    }
  })
}

const handshake = async () => {
  if (!asHttp) {
    return
  }

  const options: WebHttpRequestOptions = {
    url: `${HANDSHAKE_URL}/handshake`,
    method: 'GET',
    webHttpConfig: {
      disableCrypto: true
    }
  }

  try {
    const response = await asHttp.request(options)
    const { data: body } = response
    const { data = {} } = body
    const { publicKey = '' } = data
    asHttp.context.set(WEB_HTTP_CONTEXT.PUBLIC_KEY, publicKey)
  } catch (err) {
    console.log(err)
    throw err
  }
}

export default performHandshake
